import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { readApiJson } from '../lib/api';

const SITE_DISCLAIMER = "CBAT Academy is an independent training resource and is not affiliated with or endorsed by any government or armed force, or by ADAPT, COMPASS, Aon/cut-e, PILAPT or any other commercial assessment provider. Exercises, scoring, and readiness estimates are independently developed and unofficial.";

const SiteDisclaimer = () => {
  const { siteSettings, user, hasFullAccess } = useAuth();
  const [publicDisplayVersion, setPublicDisplayVersion] = useState('0.1.0');

  useEffect(() => {
    let active = true;
    readApiJson('/public-site-settings')
      .then((settings) => {
        if (active && settings?.display_version) setPublicDisplayVersion(settings.display_version);
      })
      .catch(() => {
        // Keep the fallback version when public settings are temporarily unavailable.
      });
    return () => { active = false; };
  }, []);

  const displayVersion = siteSettings?.display_version || publicDisplayVersion;

  return (
    <footer className="site-disclaimer" role="contentinfo" aria-label="Site disclaimer">
      <div className="site-disclaimer__inner">
        <div className="site-disclaimer__links">
          <nav className="site-disclaimer__nav" aria-label="Footer navigation">
            <Link to="/about">About</Link>
            <Link to="/guides">Guides</Link>
            <Link to="/raf-cbat-mock-test">Full Mock Test</Link>
            {/* Signed-in accounts with full access have nothing to buy. */}
            {!(user && hasFullAccess) && <Link to="/pricing">Pricing</Link>}
            <Link to="/contact">Contact Developer</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/methodology">Methodology</Link>
            <Link to="/sources">Sources</Link>
            <a
              className="site-disclaimer__trustpilot"
              href="https://www.trustpilot.com/review/cbat-academy.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="site-disclaimer__trustpilot-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="m12 2 2.45 7.54H22l-6.12 4.45 2.34 7.2L12 16.72l-6.22 4.47 2.34-7.2L2 9.54h7.55L12 2Z" />
                </svg>
              </span>
              Trustpilot
            </a>
          </nav>
          <Link className="site-disclaimer__donate" to="/donate">Donate</Link>
        </div>
        <div className="site-disclaimer__meta">
          <div className="site-disclaimer__text">{SITE_DISCLAIMER}</div>
          <div className="site-disclaimer__version">Version {displayVersion}</div>
        </div>
      </div>
    </footer>
  );
};

export default SiteDisclaimer;
